/**   
 * 订单管理
 */
export default {
  /**
   * 订单管理
   */
  projectOrderList: "/platform_project_order/select_project_order_platform", //体验项目+正式项目列表
  projectOrderInfo: "/platform_project_order/select_project_order_info", //项目详情
  productOrderList: "/shop_order/select_online_orders", //商品订单列表
  productOrderInfo: "/shop_order/select_online_orders_info", //商品订单详情
  productOrderRefund: "/shop_order/refund_order", //商品订单退款
  productOrderDeliver: "/shop_order/deliver_goods", //商品订单发货
  productOrderConfirm: "/shop_order/confirm_goods", //商品订单确认发货
  productRefundOrderList: "/platform_order_refund/select", //售后订单列表
  productRefundOrderInfo: "/platform_order_refund/get", //售后订单详情
  productRefundOrderHandle: "/store_order_refund/refund_order_update_status", //售后订单处理
};